import styles from "../../../styles/CoordinationBoards.module.css"
import { useContext, useState } from "react"
import { UserContext } from "../../../context/userContext"
import axios from "axios"
import { coordinationBoardsApiUrl } from "../../../config/microservicesUrls"
import { BoardType } from "../Types/Enums"
import { Dialog } from "primereact/dialog"
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from "primereact/checkbox"
import { Button } from "primereact/button"
import { requiredFieldIsMissing, showError, renderRequireFieldErrorMessage } from "../Utils/Utils"

const api_url = coordinationBoardsApiUrl()

const ReferralPartnerBoardForm = ({ dialogVisible, setDialogVisible, organizations, referralPartners, addBoard, toast }) => {
    const userCtx = useContext(UserContext)

    const defaultReferralPartnerBoardData = {
        type: BoardType["Referral Partner"],
        createdBy: userCtx.session.user.staff_id,
        ownerEnterpriseId: userCtx.session.user.enterprise_id,
        ownerOrganizationId: null,
        referralPartner: null,
        enabled: true,
        readOnly: false
    }

    const [referralPartnerBoardData, setReferralPartnerBoardData] = useState(defaultReferralPartnerBoardData)
    const [loading, setLoading] = useState(false)
    const [showErrors, setShowErrors] = useState(false)

    const clearForm = () => {
        setReferralPartnerBoardData(defaultReferralPartnerBoardData)
        setShowErrors(false)
        setLoading(false)
    }

    const saveReferralPartnerBoard = () => {
        //if referral partner is null, show error
        if (requiredFieldIsMissing(referralPartnerBoardData.ownerOrganizationId)
            || requiredFieldIsMissing(referralPartnerBoardData.referralPartner)) {
            setShowErrors(true)
            return
        }

        setLoading(true)

        const data = { ...referralPartnerBoardData, organizationIds: [referralPartnerBoardData.referralPartner] }

        axios
            .post(`${api_url}/boards`,
                data,
                {
                    headers: { Authorization: `Bearer ${userCtx.tokenCoordinationBoards}` },
                })
            .then(function (response) {
                setLoading(false)
                addBoard(response.data)
                clearForm()
                setDialogVisible(false)
            })
            .catch(function (response) {
                setLoading(false)
                const errors = response["response"]["data"]["errors"]
                showError(toast, errors, errors)
            })
    }


    return (
        <Dialog
            header="New Referral Partner Board"
            className={`custom_dialog ${styles.cross_org_dialog}`}
            visible={dialogVisible}
            onHide={() => {
                clearForm()
                setDialogVisible(false)
            }}
        >
            <div
                style={{
                    padding: "10px",
                }}
            >
                <div className={styles.field}>
                    <label className={styles.label}>Organization</label>
                    <div>
                        <Dropdown
                            value={referralPartnerBoardData.ownerOrganizationId}
                            filter
                            options={organizations}
                            panelClassName="custom_dropdown_panel"
                            onChange={(e) =>
                                setReferralPartnerBoardData({ ...referralPartnerBoardData, ownerOrganizationId: e.value })
                            }
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select an organization"
                            style={{ width: "100%" }}
                            className={`{${styles.selector} ${showErrors && requiredFieldIsMissing(referralPartnerBoardData.ownerOrganizationId) ? styles.invalid : ""}}`}
                        />
                        {showErrors && renderRequireFieldErrorMessage(
                            referralPartnerBoardData.ownerOrganizationId,
                            "Organization is required"
                        )}
                    </div>
                </div>
                <div className={styles.field}>
                    <label className={styles.label}>Referral Partner</label>
                    <div>
                        <Dropdown
                            value={referralPartnerBoardData.referralPartner}
                            filter
                            options={referralPartners}
                            panelClassName="custom_dropdown_panel"
                            onChange={(e) =>
                                setReferralPartnerBoardData({ ...referralPartnerBoardData, referralPartner: e.value })
                            }
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select a partner"
                            style={{ width: "100%" }}
                            className={`{${styles.selector} ${showErrors && requiredFieldIsMissing(referralPartnerBoardData.referralPartner) ? styles.invalid : ""}}`}
                        />
                        {showErrors && renderRequireFieldErrorMessage(
                            referralPartnerBoardData.referralPartner,
                            "Referral Partner is required"
                        )}
                    </div>
                </div>
                <div className={styles.field}
                    style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "flex-start",
                    }}
                >
                    <div className={styles.chkbox}>
                        <Checkbox
                            inputId="new_referralPartnerBoard_enabled"
                            name="category"
                            className={`${styles.checkbox_design} ${styles.checkbox_border}`}
                            value={referralPartnerBoardData.enabled}
                            onChange={(e) => {
                                setReferralPartnerBoardData({ ...referralPartnerBoardData, enabled: e.checked })
                            }}
                            checked={referralPartnerBoardData.enabled}
                        />
                        <label htmlFor="new_referralPartnerBoard_enabled" style={{ marginLeft: "7px" }}>
                            Enabled
                        </label>
                    </div>
                    <div className={styles.chkbox}>
                        <Checkbox
                            inputId="new_referralPartnerBoard_readonly"
                            name="category"
                            className={`${styles.checkbox_design} ${styles.checkbox_border}`}
                            value={referralPartnerBoardData.readOnly}
                            onChange={(e) => {
                                setReferralPartnerBoardData({ ...referralPartnerBoardData, readOnly: e.checked })
                            }}
                            checked={referralPartnerBoardData.readOnly}
                        />
                        <label htmlFor="new_referralPartnerBoard_readonly" style={{ marginLeft: "7px" }}>
                            Read-only
                        </label>
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        className={styles.cancel_button}
                        type="submit"
                        disabled={loading}
                        onClick={() => {
                            clearForm()
                            setDialogVisible(false)
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={styles.button}
                        type="submit"
                        style={{
                            width: "91px!important",
                            justifyContent: "center",
                        }}
                        disabled={loading}
                        onClick={() => saveReferralPartnerBoard()}
                    >
                        Create board
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}
export default ReferralPartnerBoardForm
